import React, { useState } from "react";
import classnames from "classnames";
import Rail from "web/react/components/rail/rail";
import { gettext } from "web/script/modules/django-i18n";
import LazyLoadImage from "web/react/components/lazy-load-image/lazy-load-image";
import styles from "./homepage-generic-types.css";

interface Link {
    title: string;
    url: string;
}

interface GenericType {
    title: string;
    image_url: string;
    url: string;
    links: Link[];
}

interface GenericTypeProps {
    genericType: GenericType;
}

export const LINK_LIMIT = 9;

export function GenericType({ genericType }: GenericTypeProps): JSX.Element {
    const [isExpanded, setIsExpanded] = useState(false);
    const hideLinks = genericType.links.length > LINK_LIMIT;
    return (
        <div className={styles.genericType}>
            <a href={genericType.url}>
                <LazyLoadImage
                    className={styles.genericTypeImg}
                    src={genericType.image_url}
                    alt={genericType.title}
                />
                <h4 className={styles.genericTypeTitle}>{genericType.title}</h4>
            </a>
            <ul className={classnames({ [styles.hideLinks]: hideLinks && !isExpanded })}>
                {genericType.links.map((link) => {
                    return (
                        <li className={styles.genericTypeItem} key={link.url}>
                            <a className={styles.genericTypeLink} href={link.url}>
                                {link.title}
                            </a>
                        </li>
                    );
                })}
            </ul>
            {hideLinks && !isExpanded && (
                <button
                    className={styles.moreButton}
                    type="button"
                    onClick={(): void => setIsExpanded(true)}
                >
                    {"+"}
                    {gettext("burger_menu.more_category_link") // More
                    }
                </button>
            )}
        </div>
    );
}

interface HomepageGenericTypesProps {
    genericTypes: GenericType[];
}

function HomepageGenericTypes({ genericTypes }: HomepageGenericTypesProps): JSX.Element {
    return (
        <div className={styles.genericTypes}>
            <Rail
                className={styles.genericTypeRail}
                analyticsLabel={"homepage_store_rail"}
                title={""}
                leftButtonStyle={styles.left}
                rightButtonStyle={styles.right}
                buttonIcon={"square-chevron"}
            >
                {genericTypes.map((genericType) => {
                    return <GenericType key={genericType.title} genericType={genericType} />;
                })}
            </Rail>
        </div>
    );
}

export default HomepageGenericTypes;
